<template>
<section class="post-plus-tweet px-4 py-4">
    <div class="max-w-4xl mx-auto">
        <div class="grid">
            <SmoothLoader v-for="post in posts" class="post">
                <span class="kicker block font-headline font-bold upperase text-primary-500 uppercase tracking-widest mb-2" v-html="post.kicker"></span>
                <a v-if="post.is_redirect" target="_blank" :href="post.link" class="title font-headline leading-tight block font-bold text-primary-600 text-3xl vt:text-5xl transition-colors hover:text-secondary-600 focus:text-secondary-600" v-html="post.title"></a>
                <Link v-else :href="post.link" class="title font-headline leading-tight block font-bold text-primary-600 text-3xl vt:text-5xl transition-colors hover:text-secondary-600 focus:text-secondary-600" v-html="post.title"></Link>
                <div class="prose text-gray-800 mt-2" v-if="post.excerpt">
                    <p v-html="post.excerpt"></p>
                </div>
            </SmoothLoader>
        </div>
    </div>
</section>
</template>

<script>
import { ref, computed, nextTick, watch, onMounted } from 'vue';
export default {
    props: ['data'],
    setup(props) {
        return {
            ...props.data
        }
    }
}
</script>